module.exports = __webpack_public_path__ + "static/media/camera.99967ee3.svg";